import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { MemberByDisciplinaryPanel } from './service/member-by-disciplinary.service';
import { SharedService } from '../../../../shared/sharedServices/shared.service';
import { HEC_CONSTANTS } from '../../../../utilities/constants';
import { CommonHelper } from '../../../../utilities/common.helper';


@Component({
  selector: 'kt-add-member-by-disciplinary-panel',
  templateUrl: './add-member-by-disciplinary-panel.component.html',
  styleUrls: ['./add-member-by-disciplinary-panel.component.scss'],
  providers: [MemberByDisciplinaryPanel]
})
export class AddMemberByDisciplinaryPanelComponent implements OnInit {

  public form: FormGroup;
  public isDataPresent: boolean = true
  public dropdown: any = null
  public dropdownCategories: any = null
  private pageState: string = null
  public format = { add: '', remove: '', all: '', none: '', draggable: true, locale: 'undefined' };
  public categoryTypePrimary: string = 'Primary'
  public categoryTypeSuplimentary: string = 'Supplementary'
  public isSelectedMembers: boolean = false
  public source: any = [];
  public target: any = [];


  constructor(private dialogRef: MatDialogRef<AddMemberByDisciplinaryPanelComponent>,
    private formBuilder: FormBuilder,
    private membersByDisciplinaryService: MemberByDisciplinaryPanel,
    private sharedService: SharedService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      panelId: new FormControl(null, Validators.required),
      categoryName: new FormControl(null, Validators.required),
    })

    this.pageState = this.data.pageState
    this.getPanelsList(this.data.grantId)
    this.getCategoryList(this.data.panelData.panelId ? this.data.panelData.panelId : 0)
  }


  public onButtonClick(button?) {
    this.dialogRef.close(button);
  }

  public addMembers(): void {
    if (this.pageState == 'JMP') {
      this.addMembersJMP()
    }
    else if (this.pageState == 'Steering Committee') {
      this.addMembersSteeringCommittee()
    }
    else if (this.pageState == 'HLEP') {
      this.addMembersHLEP()
    }
    else {
      this.addMemberOthers()
    }
  }

  private addMemberOthers(): void {
    this.markFormsTouched();
    if (!this.formValid())
      return;
    let payload = this.constructPayloadOthers()
    for (let i = 0; i < payload.rgaRoleViewDtoList.length; i++) {
      payload.rgaRoleViewDtoList[i].categoryName = this.form.value.categoryName ? this.form.value.categoryName : null
      payload.rgaRoleViewDtoList[i].batchId = this.data.batchId ? this.data.batchId : null
      payload.rgaRoleViewDtoList[i].subBatchId = this.data.grantId ? this.data.grantId : null
      payload.rgaRoleViewDtoList[i].rgaPanelMemberId ? delete payload.rgaRoleViewDtoList[i].rgaPanelMemberId : null
    }
    this.isDataPresent = false
    this.addMembersOtherService(payload)
  }

  private addMembersOtherService(payload): void {
    this.sharedService.saveNewMemberDetails(payload)
      .subscribe(
        (res: any) => {
          this.isDataPresent = true
          if (+res.statusCode != HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            this.sharedService.showError(res.statusDescription, 'OK', 'error-snackbar');
          }
          else {
            this.dialogRef.close({ payload, res })
            this.sharedService.showError(res.statusDescription, 'OK', 'success-snackbar');
          }
        },
        (err) => {
          this.isDataPresent = true
          if (+err.error.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.UNAUTHORIZED) {
            this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
          }
          else {
            this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
          }
        }
      )
  }

  private addMembersJMP(): void {
    this.markFormsTouched();
    if (!this.formValid())
      return;
    let payload = this.constructPayloadJMP()
    for (let i = 0; i < payload.rgaRoleViewDtoList.length; i++) {
      payload.rgaRoleViewDtoList[i].categoryName = this.form.value.categoryName ? this.form.value.categoryName : null
      payload.rgaRoleViewDtoList[i].batchId = this.data.batchId ? this.data.batchId : null
      payload.rgaRoleViewDtoList[i].subBatchId = this.data.grantId ? this.data.grantId : null
      payload.rgaRoleViewDtoList[i].rgaPanelMemberId ? delete payload.rgaRoleViewDtoList[i].rgaPanelMemberId : null
    }
    this.isDataPresent = false
    this.addMembersJMPService(payload)

  }

  private addMembersJMPService(payload): void {
    this.sharedService.saveNewMemberDetailsJMP(payload)
      .subscribe(
        (res: any) => {
          this.isDataPresent = true
          if (+res.statusCode != HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            this.sharedService.showError(res.statusDescription, 'OK', 'error-snackbar');
          }
          else {
            this.dialogRef.close({ payload, res })
            this.sharedService.showError(res.statusDescription, 'OK', 'success-snackbar');
          }
        },
        (err) => {
          this.isDataPresent = true
          if (+err.error.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.UNAUTHORIZED) {
            this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
          }
          else {
            this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
          }
        }
      )

  }

  private addMembersSteeringCommittee(): void {
    this.markFormsTouched();
    if (!this.formValid())
      return;
    let payload = this.constructPayloadJMP()
    for (let i = 0; i < payload.rgaRoleViewDtoList.length; i++) {
      payload.rgaRoleViewDtoList[i].categoryName = this.form.value.categoryName ? this.form.value.categoryName : null
      payload.rgaRoleViewDtoList[i].batchId = this.data.batchId ? this.data.batchId : null
      payload.rgaRoleViewDtoList[i].subBatchId = this.data.grantId ? this.data.grantId : null
      payload.rgaRoleViewDtoList[i].rgaPanelMemberId ? delete payload.rgaRoleViewDtoList[i].rgaPanelMemberId : null
    }
    this.isDataPresent = false
    this.addMembersSteeringCommitteeService(payload)

  }

  private addMembersSteeringCommitteeService(payload): void {
    this.sharedService.saveNewMemberDetailsSteeringCommittee(payload)
      .subscribe(
        (res: any) => {
          this.isDataPresent = true
          if (+res.statusCode != HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            this.sharedService.showError(res.statusDescription, 'OK', 'error-snackbar');
          }
          else {

            this.dialogRef.close({ payload, res })
            this.sharedService.showError(res.statusDescription, 'OK', 'success-snackbar');
          }
        },
        (err) => {
          this.isDataPresent = true
          if (+err.error.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.UNAUTHORIZED) {
            this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
          }
          else {
            this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
          }
        }
      )

  }

  private addMembersHLEP(): void {
    this.markFormsTouched();
    if (!this.formValid())
      return;
    let payload = this.constructPayloadJMP()
    for (let i = 0; i < payload.rgaRoleViewDtoList.length; i++) {
      payload.rgaRoleViewDtoList[i].categoryName = this.form.value.categoryName ? this.form.value.categoryName : null
      payload.rgaRoleViewDtoList[i].batchId = this.data.batchId ? this.data.batchId : null
      payload.rgaRoleViewDtoList[i].subBatchId = this.data.grantId ? this.data.grantId : null
      payload.rgaRoleViewDtoList[i].rgaPanelMemberId ? delete payload.rgaRoleViewDtoList[i].rgaPanelMemberId : null
    }
    this.isDataPresent = false
    this.addMembersHLEPService(payload)

  }

  private addMembersHLEPService(payload): void {
    this.sharedService.saveNewMemberDetailsHLEP(payload)
      .subscribe(
        (res: any) => {
          this.isDataPresent = true
          if (+res.statusCode != HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            this.sharedService.showError(res.statusDescription, 'OK', 'error-snackbar');
          }
          else {

            this.dialogRef.close({ payload, res })
            this.sharedService.showError(res.statusDescription, 'OK', 'success-snackbar');
          }
        },
        (err) => {
          this.isDataPresent = true
          if (+err.error.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.UNAUTHORIZED) {
            this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
          }
          else {
            this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
          }
        }
      )

  }

  private getPanelsList(grantId) {
    this.membersByDisciplinaryService.getPanelsList(grantId).subscribe(
      (response: any) => {
        if (response && response.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          this.dropdown = response['data']
        }
        else {
          this.dropdown = []
          this.sharedService.showError(response.statusDescription, 'OK', 'error-snackbar');
        }
      },
      (err) => {
        this.dropdown = []
        this.sharedService.showError(err.error, 'OK', 'error-snackbar');
      })
  }

  private getCategoryList(panelId) {
    this.sharedService.getCategoryListForTeamManagement(panelId).subscribe(
      (response: any) => {
        if (response && response.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          this.dropdownCategories = response['data']
        }
        else {
          this.dropdownCategories = []
          this.sharedService.showError(response.statusDescription, 'OK', 'error-snackbar');
        }
      },
      (err) => {
        this.dropdownCategories = []
        this.sharedService.showError(err.error, 'OK', 'error-snackbar');
      })
  }

  public getPanelMembersList(panelId) {
    this.source = []
    this.target = []
    this.isDataPresent = false
    let thematicPanelId = this.data.panelData.panelId ? this.data.panelData.panelId : 0
    this.membersByDisciplinaryService.getPanelMembersList(panelId, thematicPanelId).subscribe(response => {
      this.isDataPresent = true
      if (response && response['data'].rgaRoleViewDtoList.length == 0) {
        this.source = []
        this.sharedService.showError(HEC_CONSTANTS.ERROR_MESSGAES.NO_DATA_FOUND_FOR_PANEL, 'OK', 'error-snackbar')
      }
      if (response && +response.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
        if (response['data'] && response['data'].rgaRoleViewDtoList) {
          for (let i = 0; i < response['data'].rgaRoleViewDtoList.length; i++) {
            let mergedName = response['data'].rgaRoleViewDtoList[i].fullName + ' ' +
              (response['data'].rgaRoleViewDtoList[i].majorSubject ? '--' + response['data'].rgaRoleViewDtoList[i].majorSubject : ' ') + ' ' +
              (response['data'].rgaRoleViewDtoList[i].distinctMemberRoles ? '--' + response['data'].rgaRoleViewDtoList[i].distinctMemberRoles : ' ')
            response['data'].rgaRoleViewDtoList[i].mergedField = mergedName
          }
          this.source = response['data']
        }
      }
      else {
        this.source = []
        this.sharedService.showError(response.statusDescription, 'OK', 'error-snackbar');
      }
    },
      (err) => {
        this.isDataPresent = true
        this.source = []
        this.sharedService.showError(err.error, 'OK', 'error-snackbar');
      })
  }

  private getConditionalPanelMembers(categoryName, panelId) {
    this.isDataPresent = false
    this.source = []
    this.target = []
    let thematicPanelId = this.data.panelData.panelId ? this.data.panelData.panelId : 0

    this.membersByDisciplinaryService.getConditionalPanelMembers(categoryName, panelId, thematicPanelId).subscribe(
      response => {
        this.isDataPresent = true
        if (response && response['data'].rgaRoleViewDtoList.length == 0) {
          this.source = []
          this.sharedService.showError(HEC_CONSTANTS.ERROR_MESSGAES.NO_DATA_FOUND_FOR_PANEL, 'OK', 'error-snackbar')
        }
        if (response && +response.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          if (response['data'] && response['data'].rgaRoleViewDtoList) {
            for (let i = 0; i < response['data'].rgaRoleViewDtoList.length; i++) {
              let mergedName = response['data'].rgaRoleViewDtoList[i].fullName + ' ' +
                (response['data'].rgaRoleViewDtoList[i].majorSubject ? '--' + response['data'].rgaRoleViewDtoList[i].majorSubject : ' ') + ' ' +
                (response['data'].rgaRoleViewDtoList[i].distinctMemberRoles ? '--' + response['data'].rgaRoleViewDtoList[i].distinctMemberRoles : ' ')
              response['data'].rgaRoleViewDtoList[i].mergedField = mergedName
            }
            this.source = response['data']

          }
        }
        else {
          this.source = []
          this.sharedService.showError(response.statusDescription, 'OK', 'error-snackbar');
        }
      },
      (err) => {
        this.isDataPresent = true
        this.source = []
        this.sharedService.showError(err.error, 'OK', 'error-snackbar');
      }
    )
  }

  private markFormsTouched(): void {
    CommonHelper.markFormGroupTouched(this.form);
    if (this.target && this.target.length == 0) {
      this.isSelectedMembers = true
    }
    else {
      this.isSelectedMembers = false
    }
  }

  private formValid(): boolean {
    return this.form.valid && this.target.length > 0
  }

  private constructPayloadOthers() {
    for (let i = 0; i < this.target.length; i++) {
      if (this.target[i].mergedField) {
        delete this.target[i].mergedField
      }
    }
    let payload = {

      addNewMember: true,
      panelId: this.data.panelData.panelId ? this.data.panelData.panelId : null,
      panelName: this.data.panelData.panelName ? this.data.panelData.panelName : null,
      rgaRoleViewDtoList: this.target,
    }
    return payload;
  }

  private constructPayloadJMP() {
    for (let i = 0; i < this.target.length; i++) {
      if (this.target[i].mergedField) {
        delete this.target[i].mergedField
      }
    }
    let payload = {
      addNewMember: true,
      rgaRoleViewDtoList: this.target,
    }
    return payload;
  }

  public showPanelMembers(): boolean {
    return (this.form && this.form.value.panelId != '' && 
            this.form.value.panelId != null && 
            this.form.value.panelId != undefined)
  }

  public getPrimaryData(event): void {
    this.categoryTypePrimary = event.target.checked == true ? event.target.value : null
    let categoryName = null
    if ((this.categoryTypePrimary == 'Primary' && this.categoryTypeSuplimentary == 'Supplementary')) {
      categoryName = 'All'
    }
    else if (this.categoryTypePrimary == null) {
      if (this.categoryTypeSuplimentary == 'Supplementary') {
        categoryName = this.categoryTypeSuplimentary
      }
    }
    else if (this.categoryTypePrimary != null) {
      categoryName = this.categoryTypePrimary
    }
    else { }
    if (categoryName) {
      this.getConditionalPanelMembers(categoryName, this.form.value.panelId)
    }
    else {
      this.source = []
      this.target = []
    }

  }

  public getSuplimentaryData(event): void {
    debugger
    this.categoryTypeSuplimentary = event.target.checked == true ? event.target.value : null
    let categoryName = null
    if (this.categoryTypePrimary == 'Primary' && this.categoryTypeSuplimentary == 'Supplementary') {
      categoryName = 'All'
    }
    else if (this.categoryTypeSuplimentary == null) {
      if (this.categoryTypePrimary == 'Primary') {
        categoryName = this.categoryTypePrimary
      }
    }
    else if (this.categoryTypeSuplimentary != null) {
      categoryName = this.categoryTypeSuplimentary
    }
    else {

    }

    if (categoryName) {
      this.getConditionalPanelMembers(categoryName, this.form.value.panelId)
    }
    else {
      this.source = []
      this.target = []
    }

  }
}
